import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ProjectCloumn from "./components/ProjectCloumn";
import "./reportproject.css";
import { useLocation } from "react-router-dom";
import { useLoading } from "../../../../context/loadingcontext";
import { postData } from "../../../Utils/Baseurl";
import AllHeading from "./components/AllHeading";
const ViewProjectReport = () => {
  const [data, setData] = useState(null);
  const { setCirleLoading } = useLoading();

  const location = useLocation();

  const id = location?.state;

  useEffect(() => {
    if (id) {
      fetchViewData();
    }
  }, [id]);

  const fetchViewData = async () => {
    setCirleLoading(true);
    const formdata = new FormData();
    formdata.append("project_id", id);
    try {
      const res = await postData("api/gettimeline/", formdata);
      if (res?.status) {
        setData(res?.data);
      } else {
        setData(null);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div style={{ padding: "0px 10px" }}>
        <AllHeading>Project</AllHeading>
        <ProjectCloumn project={data?.project} milestones={data?.milestones} />
      </div>
    </DashboardLayout>
  );
};

export default ViewProjectReport;
